(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	var roles = ['Administrators', 'DAC Content Administrator', 'DAC Content User'];
        $stateProvider
        .state('dac-content-main.nasrac-package', {
            parent: 'dac-content-main',
            url: '/nasrac-package',
            templateUrl: 'app/dac-content/nasrac-package/nasrac-packages.html',
            controller: 'NasracPackageController',
            controllerAs: 'vm',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.nasracPackage.home.title'
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nasracPackage');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dac-content-main.nasrac-package.new', {
            parent: 'dac-content-main.nasrac-package',
            url: '/new',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-package/nasrac-package-dialog.html',
                    controller: 'NasracPackageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                packageBsgHandle: null,
                                packageId: null,
                                packageName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-package', null, { reload: 'dac-content-main.nasrac-package' });
                }, function() {
                    $state.go('dac-content-main.nasrac-package');
                });
            }]
        })
        .state('dac-content-main.nasrac-package.edit', {
            parent: 'dac-content-main.nasrac-package',
            url: '/{id}/edit',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-package/nasrac-package-dialog.html',
                    controller: 'NasracPackageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NasracPackage', function(NasracPackage) {
                            return NasracPackage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-package', null, { reload: 'dac-content-main.nasrac-package' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dac-content-main.nasrac-package.delete', {
            parent: 'dac-content-main.nasrac-package',
            url: '/{id}/delete',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-package/nasrac-package-delete-dialog.html',
                    controller: 'NasracPackageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['NasracPackage', function(NasracPackage) {
                            return NasracPackage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-package', null, { reload: 'dac-content-main.nasrac-package' });
                }, function() {
                    $state.go('^');
                });
            }]
        }).state('dac-content-main.nasrac-package.unusedPckList', {
            parent: 'dac-content-main.nasrac-package',
            url: '/unusedPckList',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-package/nasrac-package-unusedlist-dialog.html',
                    controller: 'NasracPackageUnusedListDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['NasracPackage', function(NasracPackage) {
                            //return NasracPackage.get({id : $stateParams.id}).$promise;
                            return {
                                id : null
                            }
                        }]
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-package', null, { reload: 'dac-content-main.nasrac-package' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
